let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("auo6z")).then(() => parcelRequire('7hjEd'));